import forEach from 'lodash/forEach'

type OfflineListener = (isOffline: boolean) => void

const offline = {
  value: false,

  get isOffline() {
    return this.value
  },
  set isOffline(value: boolean) {
    if (this.value === value) {
      return
    }

    this.value = value
    forEach(Array.from<OfflineListener>(this.listeners), listener => listener(value))
  },

  check() {
    if (typeof window === 'undefined') {
      this.isOffline = false
      return
    }

    this.isOffline = !navigator.onLine
  },

  listeners: new Set<OfflineListener>(),
  addEventListener(listener: OfflineListener) {
    this.listeners.add(listener)
  },
  removeEventListener(listener: OfflineListener) {
    this.listeners.delete(listener)
  },
}

if (typeof window !== 'undefined') {
  window.addEventListener('online', () => {
    offline.isOffline = false
  })
  window.addEventListener('offline', () => {
    offline.isOffline = true
  })

  offline.check()
}

export default offline
